export const ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  CONTACT: '/contact',
  BLOG: '/blog',
  PRIVACY: '/privacy',
  TERMS: '/terms',
  PRICING: '/pricing',
  SCHOOLS: '/schools',
  SCHOOL_DETAIL: '/schools/:slug',
  SCHOOL_SYLLABUS: '/schools/:slug/syllabus',
  PARASHARI_LEARN: '/schools/parashari/learn',
  JAIMINI_LEARN: '/schools/jaimini/learn',
  BNN_LEARN: '/schools/bnn/learn',
  KP_LEARN: '/schools/kp/learn',
  LAL_KITAB_LEARN: '/schools/lal-kitab/learn',
  NUMEROLOGY_LEARN: '/schools/numerology/learn',
  SURYA_SIDDHANTA_LEARN: '/schools/surya-siddhanta/learn',
  PANCHANG_LEARN: '/schools/panchang/learn',
  VASTU_LEARN: '/schools/vastu/learn',
  SWARA_VIGYAN_LEARN: '/schools/swara-vigyan/learn',
  YANTRA_VIDYA_LEARN: '/schools/yantra-vidya/learn',
  TANTRA_LEARN: '/schools/tantra/learn',
  JAIMINI_BRIDGE_COURSE: '/schools/jaimini/learn/courses/parashari-to-jaimini-bridge',
  JAIMINI_BRIDGE_SYLLABUS: '/schools/jaimini/learn/courses/parashari-to-jaimini-bridge/syllabus',
  JAIMINI_BRIDGE_LESSON:
    '/schools/jaimini/learn/courses/parashari-to-jaimini-bridge/:lessonSlug',
  /** @deprecated Use JAIMINI_BRIDGE_COURSE - kept for legacy redirects */
  JAIMINI_BRIDGE_COURSE_LEGACY: '/schools/jaimini/learn/parashari-to-jaimini-bridge',
  SCHOOL_DASHBOARD: '/schools/:slug/dashboard',
  LOGIN: '/login',
  REGISTER: '/register',
  ACCESS_REQUEST: '/access-request',
  FORGOT_PASSWORD: '/forgot-password',
  DASHBOARD: '/dashboard',
  COURSES: '/courses',
  COURSE_DETAIL: '/courses/:courseId',
  LESSON: '/lessons/:lessonId',
  BATCHES: '/batches',
  BATCH_DETAIL: '/batches/:batchId',
  BATCH_ASSIGNMENT_TAKE: '/batches/:batchId/assignments/:assignmentId',
  BATCH_ASSIGNMENT_REVIEW: '/batches/:batchId/assignments/:assignmentId/review',
  BATCH_PATH_TOPIC: '/batches/:batchId/path/:topicId',
  BATCH_PATH_ASSESSMENT_TAKE: '/batches/:batchId/path/:topicId/assessments/:assessmentId',
  INVITE: '/invite/:token',
  COMMUNITY: '/community',
  COMMUNITY_CHANNEL: '/community/channels/:channelId',
  ASSESSMENTS: '/assessments',
  ASSESSMENT_TAKE: '/assessments/:quizId/take',
  CALENDAR: '/calendar',
  REMINDERS: '/reminders',
  SADHANA: '/sadhana',
  CERTIFICATES: '/certificates',
  CERTIFICATE_VERIFY: '/verify/:code',
  PROGRAMS: '/programs',
  PROGRAM_DETAIL: '/programs/:kind/:id',
  MARKETING_ASK_GURU: '/ask-guru',
  MARKETING_SANGHA: '/sangha',
  MARKETING_CERTIFICATIONS: '/certifications',
  BOOKMARKS: '/bookmarks',
  NOTES: '/notes',
  STUDY_MATERIALS: '/study-materials',
  PRIVATE_NOTES: '/private-notes',
  AI: '/ai',
  AI_TUTOR: '/ai/tutor',
  AI_CHART_LAB: '/ai/tutor/chart-lab',
  AI_CHAT: '/ai/chat',
  AI_MENTOR: '/ai/mentor',
  AI_REVISION: '/ai/revision',
  AI_FLASHCARDS: '/ai/flashcards',
  AI_QUIZ: '/ai/quiz-generator',
  AI_SUMMARY: '/ai/lesson-summary',
  AI_ASK: '/ai/ask-anything',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  MY_ACTIVITY: '/settings/activity',
  ADMIN: '/admin',
  ADMIN_USERS: '/admin/users',
  ADMIN_TEACHERS: '/admin/teachers',
  ADMIN_SCHOOLS: '/admin/schools',
  ADMIN_BATCHES: '/admin/batches',
  ADMIN_COURSE_BUILDER: '/admin/courses/builder',
  ADMIN_PERMISSIONS: '/admin/permissions',
  ADMIN_ANALYTICS: '/admin/analytics',
  ADMIN_PAYMENTS: '/admin/payments',
  ADMIN_NOTIFICATIONS: '/admin/notifications',
  ADMIN_MODERATION: '/admin/moderation',
} as const;

export type RouteKey = keyof typeof ROUTES;
